import { Money, Percentage } from "../core";
export function parseServiceFeeQuote(quote) {
    if (quote === null || quote === undefined) {
        return null;
    }
    return {
        percentage: Percentage.fromNumber((100 * quote.percentage.numerator) / quote.percentage.denominator),
        min: Money.fromBackend(quote.minFee),
        max: Money.fromBackend(quote.maxFee),
        deliveryOnly: quote.deliveryOnly,
    };
}
